import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const userPublisherDataAction = createAsyncThunk(
    'user-publisher-data',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/user-publisher-data`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userPublisherDataSlice = createSlice({
    name: 'user-publisher-data',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userPublisherDataAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userPublisherDataAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(userPublisherDataAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const userPublisherDataReducer = userPublisherDataSlice.reducer